interface JSONLDSchemaProps {
  schema: Record<string, unknown>;
  id?: string;
}

export default function JSONLDSchema({ schema, id }: JSONLDSchemaProps) {
  // For static builds, render the script tag with proper JSON-LD injection
  return (
    <script
      type="application/ld+json"
      id={id}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema, null, 0),
      }}
    />
  );
}

// Specialized schema components with better naming
export function WebsiteSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="website-schema" />;
}

export function ProductSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="product-schema" />;
}

export function OnlineBusinessSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="onlinebusiness-schema" />;
}

export function BreadcrumbSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="breadcrumb-schema" />;
}

export function FAQSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="faq-schema" />;
}

export function ServiceSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="service-schema" />;
}

export function HowToSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="howto-schema" />;
}

export function AboutPageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="about-page-schema" />;
}

export function ContactPageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="contact-page-schema" />;
}

export function AffiliatePageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="affiliate-page-schema" />;
}

export function PrivacyPageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="privacy-page-schema" />;
}

export function TermsPageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="terms-page-schema" />;
}

export function WebPageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="webpage-schema" />;
}

export function ReviewSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="review-schema" />;
}

export function MerchantReturnPolicySchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="merchant-return-policy-schema" />;
}

export function FAQPageSchema({ schema }: { schema: Record<string, unknown> }) {
  return <JSONLDSchema schema={schema} id="faqpage-schema" />;
}
